import { TestLocators } from 'constants/Locators';

import { MUI } from 'ci-esi-web-shared';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { colors } from 'styles/theme/colors';

import { AlertDialogWithAnyActions } from '../AlertDialogWithAnyActions';

export interface AlertDialogProps {
  isOpen: boolean;
  title: string;
  messages: string[] | null;
  onClose(): void;
  onConfirm?(): void;
  testId?: TestLocators;
  buttonTestId?: TestLocators;
  confirmButtonText?: string;
  cancelButtonText?: string;
  dialogTestId?: TestLocators;
  optionalBodyContent?: string[];
}
export function AlertDialog({
  isOpen,
  onClose,
  title,
  messages = [],
  testId,
  buttonTestId,
  confirmButtonText,
  cancelButtonText,
  dialogTestId,
  onConfirm,
  optionalBodyContent,
}: AlertDialogProps) {
  const { t } = useTranslation();
  const confirmButtonTextValue = confirmButtonText ?? t(translations.COMMON.OK);
  const handleConfirm = onConfirm ?? onClose;
  const useConfirmAndCancelButtons = Boolean(cancelButtonText);

  const buttons = useMemo(() => {
    return (
      <>
        <MUI.Button
          autoFocus
          onClick={handleConfirm}
          variant="contained"
          size="small"
          sx={{
            color: colors.grey60,
            backgroundColor: 'warning.main',
            padding: 1,
            fontSize: 14,
            '&:hover': { backgroundColor: 'warning.dark' },
          }}
          data-testid={buttonTestId}
        >
          {confirmButtonTextValue}
        </MUI.Button>
        {useConfirmAndCancelButtons && (
          <MUI.Button
            autoFocus
            onClick={onClose}
            variant="contained"
            color="secondary"
            size="small"
            sx={{ padding: 1, fontSize: 14 }}
          >
            {cancelButtonText}
          </MUI.Button>
        )}
      </>
    );
  }, [useConfirmAndCancelButtons, onClose, buttonTestId, cancelButtonText, handleConfirm, confirmButtonTextValue]);

  return (
    <AlertDialogWithAnyActions
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      messages={messages}
      buttonsContent={buttons}
      testId={testId}
      dialogTestId={dialogTestId}
      optionalBodyContent={optionalBodyContent}
    />
  );
}
